<template>
  <el-card class="data" v-loading="loading">
    <div class="data-title flex-space-between" slot="header">
      <p>Labels</p>
      <div class="float-right">
        <LabelsFilters />
        <el-tooltip content="Insert" placement="top">
          <el-button
            type="success"
            circle
            icon="el-icon-plus"
            @click.prevent="insert()"
            class="ml10"
          ></el-button>
        </el-tooltip>
        <DialogLabel />
      </div>
    </div>
    <el-table
      :data="labels.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      @expand-change="expand"
    >
      <el-table-column type="expand" label="Details" width="100%">
        <template slot-scope="props">
          <div v-if="artists.length > 0 && props.row.id == artists[0].label_id">
            <div class="inline-img" v-for="a in artists" :key="a.artist.id">
              <el-tag>
                <a :href="`${url}${a.artist.id}`" target="_blank">{{
                  a.artist.name
                }}</a>
              </el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Label name"
        prop="name"
        sortable
      ></el-table-column>
      <el-table-column label="Status" sortable align="right" prop="active">
        <template slot-scope="props">
          <el-tag v-if="props.row.active" type="success">
            Published
          </el-tag>
          <el-tag v-else type="danger">
            Not Published
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip
            content="Publish"
            placement="top"
            v-if="!props.row.active"
          >
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-top"
              @click="publishLabel(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            content="Unpublish"
            placement="top"
            v-if="props.row.active"
          >
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-bottom"
              @click="unpublishLabel(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Edit" placement="right">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="labels.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="labels.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import LabelsFilters from '../components/LabelsFilters'
import DialogLabel from '../components/DialogLabel'

export default {
  components: {
    LabelsFilters,
    DialogLabel
  },

  computed: {
    ...mapState('newReleasesLabels', [
      'labels',
      'artists',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading'
    ])
  },

  data() {
    return {
      url: 'https://app.syncvault.com/artist/',
      label: {
        id: null,
        name: null
      }
    }
  },

  methods: {
    ...mapActions('newReleasesLabels', [
      'read',
      'publish',
      'unpublish',
      'readArtists'
    ]),
    ...mapMutations('newReleasesLabels', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setSelectedLabel',
      'setDialog'
    ]),

    openEdit(label) {
      this.setSelectedLabel(label)
      this.setDialog(true)
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    publishLabel(id) {
      this.$confirm('You will publish this label. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.publish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },
    unpublishLabel(id) {
      this.$confirm('You will unpublish this label. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.unpublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Unpublish cancelled'
          })
        })
    },
    insert() {
      this.setDialog(true)
      this.setSelectedLabel(this.label)
    },
    expand(row, expanded) {
      // nasty hack -> close currently expanded row when another is opened
      if (expanded.length === 0) return
      const currentExpandedIcon = document.querySelector(
        '.el-table__expand-icon.el-table__expand-icon--expanded'
      )
      if (currentExpandedIcon) currentExpandedIcon.click()

      if (expanded.find(e => e.id === row.id)) {
        this.readArtists(row.id)
      }
    }
  },

  created() {
    this.read()
  }
}
</script>

<style scoped>
.inline-img {
  display: inline-block;
  padding-right: 10px;
}
.gallery {
  height: 150px;
}
</style>
